import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-slate-950 text-slate-400 py-12 border-t border-slate-800" data-id="element-41">
        <div className="max-w-6xl mx-auto px-4" data-id="element-42">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-43">
            {/* Brand */}
            <div className="text-center md:text-left" data-id="element-44">
              <h3 className="text-white font-bold text-lg mb-2" data-id="element-45">
                Inglés Nativo en 14 Días
              </h3>
              <p className="text-sm text-slate-500" data-id="element-46">
                Aprende a responder como un nativo en USA
              </p>
            </div>

            {/* Links */}
            <div className="flex items-center gap-6 text-sm" data-id="element-47">
              <button onClick={() => setPrivacyOpen(true)} className="hover:text-yellow-400 transition-colors underline underline-offset-4" data-id="element-48">
                Privacy Policy
              </button>
              <span className="text-slate-700" data-id="element-49">|</span>
              <button onClick={() => setTermsOpen(true)} className="hover:text-yellow-400 transition-colors underline underline-offset-4" data-id="element-50">
                Terms of Service
              </button>
            </div>

            {/* Copyright */}
            <div className="text-sm text-slate-500 text-center md:text-right" data-id="element-51">
              <p data-id="element-52">
                &copy; {new Date().getFullYear()} Todos los derechos reservados
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Privacy Policy" data-id="element-53">
        <div className="prose prose-slate max-w-none" data-id="element-54">
          <p className="text-slate-600 mb-4" data-id="element-55">
            <strong data-id="element-56">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-57">
            1. Información que Recopilamos
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-58">
            Cuando compras "Inglés Nativo en 14 Días (USA)", recopilamos
            información necesaria para procesar tu pedido, incluyendo:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-59">
            <li data-id="element-60">Nombre y dirección de correo electrónico</li>
            <li data-id="element-61">
              Información de pago (procesada de forma segura por nuestro
              proveedor de pagos)
            </li>
            <li data-id="element-62">
              Dirección IP y datos de navegación para prevención de fraude
            </li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-63">
            2. Cómo Usamos Tu Información
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-64">
            Utilizamos tu información personal para:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-65">
            <li data-id="element-66">Procesar y entregar tu compra del PDF</li>
            <li data-id="element-67">Enviarte el producto digital y actualizaciones relacionadas</li>
            <li data-id="element-68">Proporcionar soporte al cliente</li>
            <li data-id="element-69">Mejorar nuestros productos y servicios</li>
            <li data-id="element-70">Cumplir con obligaciones legales</li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-71">
            3. Protección de Datos
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-72">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información personal contra acceso no autorizado,
            pérdida o alteración. Todos los pagos son procesados a través de
            plataformas seguras que cumplen con los estándares PCI DSS.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-73">
            4. Compartir Información
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-74">
            No vendemos ni alquilamos tu información personal a terceros.
            Podemos compartir información con:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-75">
            <li data-id="element-76">Procesadores de pago para completar transacciones</li>
            <li data-id="element-77">
              Proveedores de servicios que nos ayudan a operar nuestro negocio
            </li>
            <li data-id="element-78">Autoridades legales cuando sea requerido por ley</li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-79">
            5. Tus Derechos
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-80">Tienes derecho a:</p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-81">
            <li data-id="element-82">Acceder a tu información personal</li>
            <li data-id="element-83">Corregir datos inexactos</li>
            <li data-id="element-84">Solicitar la eliminación de tus datos</li>
            <li data-id="element-85">Oponerte al procesamiento de tu información</li>
            <li data-id="element-86">Retirar tu consentimiento en cualquier momento</li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-87">
            6. Cookies
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-88">
            Utilizamos cookies esenciales para el funcionamiento del sitio web y
            cookies analíticas para mejorar tu experiencia. Puedes controlar las
            cookies a través de la configuración de tu navegador.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-89">
            7. Contacto
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-90">
            Si tienes preguntas sobre esta política de privacidad o deseas
            ejercer tus derechos, contáctanos en:
          </p>
          <p className="text-slate-700 mb-4" data-id="element-91">
            <strong data-id="element-92">Email:</strong> privacy@ingles14dias.com
          </p>
        </div>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Terms of Service" data-id="element-93">
        <div className="prose prose-slate max-w-none" data-id="element-94">
          <p className="text-slate-600 mb-4" data-id="element-95">
            <strong data-id="element-96">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-97">
            1. Aceptación de Términos
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-98">
            Al comprar y usar "Inglés Nativo en 14 Días (USA)", aceptas estos
            términos de servicio. Si no estás de acuerdo, no uses el producto.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-99">
            2. Descripción del Producto
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-100">
            "Inglés Nativo en 14 Días (USA)" es un producto digital (PDF) que
            contiene:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-101">
            <li data-id="element-102">
              20 escenas de conversación en inglés para situaciones reales en
              USA
            </li>
            <li data-id="element-103">Frases nativas con traducción al español</li>
            <li data-id="element-104">Guía de pronunciación y práctica</li>
            <li data-id="element-105">Plan de mantenimiento de 7 minutos diarios</li>
          </ul>
          <p className="text-slate-700 mb-4" data-id="element-106">
            Este es un producto educativo digital. No garantizamos resultados
            específicos, ya que el aprendizaje depende del esfuerzo individual.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-107">
            3. Licencia de Uso
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-108">
            Al comprar el producto, recibes una licencia personal, no
            transferible y no exclusiva para:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-109">
            <li data-id="element-110">Descargar y usar el PDF para tu aprendizaje personal</li>
            <li data-id="element-111">Imprimir una copia para uso personal</li>
          </ul>
          <p className="text-slate-700 mb-4" data-id="element-112">
            <strong data-id="element-113">NO puedes:</strong>
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-114">
            <li data-id="element-115">Compartir, distribuir o revender el producto</li>
            <li data-id="element-116">Publicar el contenido en línea o en redes sociales</li>
            <li data-id="element-117">Modificar o crear obras derivadas</li>
            <li data-id="element-118">Usar el contenido con fines comerciales</li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-119">
            4. Pago y Entrega
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-120">
            El precio actual es de $6.39 USD. El pago se procesa de forma segura
            a través de nuestro proveedor de pagos. Después de completar la
            compra, recibirás:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-121">
            <li data-id="element-122">Un email de confirmación inmediato</li>
            <li data-id="element-123">Acceso de descarga instantánea al PDF</li>
            <li data-id="element-124">Acceso de por vida al producto</li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-125">
            5. Política de Reembolso
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-126">
            Ofrecemos una garantía de satisfacción de 30 días. Si no estás
            satisfecho con el producto, contáctanos dentro de los 30 días
            posteriores a la compra para solicitar un reembolso completo. Debes:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-127">
            <li data-id="element-128">Enviar tu solicitud a refunds@ingles14dias.com</li>
            <li data-id="element-129">Incluir tu número de pedido</li>
            <li data-id="element-130">Explicar brevemente el motivo (opcional)</li>
          </ul>
          <p className="text-slate-700 mb-4" data-id="element-131">
            Procesaremos tu reembolso en 5-7 días hábiles.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-132">
            6. Propiedad Intelectual
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-133">
            Todo el contenido de "Inglés Nativo en 14 Días (USA)", incluyendo
            textos, diseños, gráficos y materiales, está protegido por derechos
            de autor y es propiedad exclusiva de nuestro negocio. Cualquier uso
            no autorizado constituye una violación de estos derechos.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-134">
            7. Limitación de Responsabilidad
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-135">
            Este producto es una herramienta educativa. No garantizamos
            resultados específicos en el aprendizaje del inglés. Tu progreso
            depende de tu dedicación y práctica. No somos responsables de:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-136">
            <li data-id="element-137">Resultados de aprendizaje individuales</li>
            <li data-id="element-138">Oportunidades laborales o sociales</li>
            <li data-id="element-139">Problemas técnicos de descarga (ofrecemos soporte)</li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-140">
            8. Modificaciones
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-141">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios entrarán en vigor inmediatamente después de su
            publicación. El uso continuado del producto después de los cambios
            constituye tu aceptación de los nuevos términos.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-142">
            9. Contacto
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-143">
            Para preguntas sobre estos términos, contáctanos en:
          </p>
          <p className="text-slate-700 mb-4" data-id="element-144">
            <strong data-id="element-145">Email:</strong> support@ingles14dias.com
          </p>
        </div>
      </Modal>
    </>;
}